// extracted by mini-css-extract-plugin
export default {"guideBox":"index-module--guideBox--6ff97","guideMessage":"index-module--guideMessage--0f2a8"};